<template>
	<v-dialog
		v-bind="customProps"
		:model-value="isActive"
		transition="dialog-bottom-transition"
		scrollable
	>
		<v-card
			:class="[
				{'fullscreen': customProps.fullscreen},
				{'scrollable': customProps.scrollable},
			]"
			class="ao-dialog-layout-card"
		>

			<div
				class="dialog-card-header d-flex pa-6"
				:class="{'header-line': showHeaderLine}"
			>

				<div class="d-flex flex-column">
					<span class="ao-h1">{{ title }}</span>
					<span
						v-if="subtitle"
						class="text-textMuted ao-p3-regular"
					>
						{{ subtitle }}
					</span>
				</div>

				<v-spacer/>

				<ao-icon-btn
					iconName="close"
					class="ms-2"
					variant="text"
					@click="onCancel('header')"
				/>

			</div>

			<div class="dialog-card-content pa-6">

				<slot v-if="isActive" name="default"></slot>

			</div>

			<div
				class="dialog-card-footer pa-6"
				:class="{'footer-line': showFooterLine}"
			>

				<ao-btn
					variant="text"
					class="me-6"
					@click="onCancel('footer')"
				>
					{{ $t('Close') }}
				</ao-btn>

			</div>

		</v-card>
	</v-dialog>
</template>

<script setup>
// import { computed } from 'vue'
// import { useI18n } from 'vue-i18n'

// import {
// 	DIALOG_FORM_TYPES,
// 	DIALOG_FORM_SAVE_ACTION_EMITS,
// 	DIALOG_FORM_MULTI_FORM_STEP_TYPES,
// 	DIALOG_FORM_SAVE_ACTION_TYPES,
// 	ABSTRACT_DIALOG_FORM_PROPS,
// 	ABSTRACT_DIALOG_FORM_EMITS,
// } from '@/config/dialogForm/dialogFormConfig'

const props = defineProps({
	isActive: {
		type: Boolean,
		default: false,
	},

	customProps: {
		type: Object,
		default: () => ({}),
	},

	title: {
		type: String,
		default: null,
	},

	subtitle: {
		type: String,
		default: null,
	},

	showHeaderLine: {
		type: Boolean,
		default: false,
	},

	showFooterLine: {
		type: Boolean,
		default: false,
	},
	// ...ABSTRACT_DIALOG_FORM_PROPS,
})

const emit = defineEmits({
	'cancel': null,
	// ...ABSTRACT_DIALOG_FORM_EMITS,
})

// const { t: $t } = useI18n()

const onCancel = (from) => {
	emit('cancel', {
		from,
	})
}
</script>

<style lang="scss">
.ao-dialog-layout-card {
	display: flex;
	flex-direction: column;
	width: 100%;
	height:100%;

	.header-line {
		border-bottom: 1px solid #e6eef3;
	}

	.footer-line {
		border-top: 1px solid #e6eef3;
	}

	.dialog-card-content {
		overflow-y: auto;
	}

	&.fullscreen {
		.dialog-card-content {
			flex: 1 1;
		}

		.dialog-card-header,
		.dialog-card-footer {
			flex: 0 0;
		}
	}

	&.scrollable {
		.dialog-card-content {
			overflow-y: auto;
		}
	}

}
</style>
